/**
 * Loading related actions can be created here
 */

import { GET_AGENTS , CREATE_AGENT_TRANSACTION , GET_AGENTS_TRANSACTIONS,GET_AGENTS_ACTIONS, GET_USER_ACTIONS, GET_AGENT_PRIVILEGES, GET_OPERATOR_PRIVILEGE_ACTIONS } from "./action-types";
import { GET_AGENTS_URL , CREATE_AGENT_TRANSACTION_URL , GET_AGENTS_TRANSACTIONS_URL, UPDATE_AGENT_TYPE_URL, UPDATE_AGENT_TRANSACTION_STATUS_URL, GET_AGENTS_BY_OPERATOR_CODE_URL, GET_PREPAID_OTA_ACCOUNT_URL, GET_AGENT_ACTIONS_URL, GET_USER_ACTIONS_URL, DELETE_USER_PRIVILEGE_URL, INSERT_USER_PRIVILEGE_URL, GET_AGENT_PRIVILEGES_URL, GET_OPERATOR_PRIVILEGE_ACTIONS_URL, INSERT_OPERATOR_PRIVILEGE_ACTION_URL, DELETE_OPERATOR_PRIVILEGE_ACTION_URL, CREATE_AGENT_PRIVILEGE_URL, CREATE_AGENT_URL, UPDATE_AGENT_URL, UPDATE_AGENT_ACTIVE_STATUS_URL, DELETE_AGENT_URL, FETCH_AGENTS_LEDGER_URL, FETCH_TRANSACTIONS_BY_PNR_URL, FETCH_POST_PAID_AGENT_UNPAID_TICKETS_URL, GET_AGENT_NAMES_BY_OPERATOR_CODE_URL, GET_AGENT_UPDATE_LOGS_BY_ID_URL, GET_OPERATOR_MAX_DISCOUNT_PRIVILEGE_URL, UPSERT_OPERATOR_MAX_DISCOUNT_PRIVILEGE_URL } from "./../utils/api-url";
import { getCall, postCall } from "../utils/network.util";
import { API_NORTH_ADMIN_URL, API_B2B_ADMIN_BASE_URL, API_SRMS_ADMIN_BASE_URL } from "../app.config";

export const getAgents = (prePaidOnly=false,postPaidOnly=false,onSuccess=()=>{},onFailure=()=>{},operatorCode,includeInactive=false)=>{
    return{
        type:GET_AGENTS,
        payload: {
            url:GET_AGENTS_URL,
            api:postCall,
            apiPayload:{
              operatorCode: operatorCode || global.operatorCode,
              prePaidOnly:prePaidOnly,
              postPaidOnly:postPaidOnly,
              privilege:global.privilege,
              userName:global.userName,
              includeInactive:includeInactive
            },
            onSuccess:onSuccess,
            onFailure:onFailure
        }
    }
}

export const getAgentActions = (onSuccess=()=>{},onFailure=()=>{})=>{
  var fetchedData = getCall(`${GET_AGENT_ACTIONS_URL}?privilege=${global.privilege}`, {
    operator_code:global.operatorCode
  });
  fetchedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get agent actions.")
    }

  })      
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to get agent actions!");
  })
}

export const getUserActions = (userName,privilege,onSuccess=()=>{},onFailure=()=>{})=>{
  var fetchedData = postCall(GET_USER_ACTIONS_URL, {
    operator_code:global.operatorCode,
    userName:userName,
    privilege:privilege
  });
  fetchedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get user actions.")
    }

  })      
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to get user actions!");
  })
}

export const insertUserActions = (userName,privilege,onSuccess=()=>{},onFailure=()=>{})=>{
  var insertedData = postCall(INSERT_USER_PRIVILEGE_URL, {
    operator_code:global.operatorCode,
    userName:userName,
    agentPrivilege:privilege
  });
  insertedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get user actions.")
    }

  })      
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to get user actions!");
  })
}

export const deleteUserActions = (userName,privilege,onSuccess=()=>{},onFailure=()=>{})=>{
  var deletedData = postCall(DELETE_USER_PRIVILEGE_URL, {
    operator_code:global.operatorCode,
    userName:userName,
    agentPrivilege:privilege
  });
  deletedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get user actions.")
    }

  })      
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to get user actions!");
  })
}

export const getAgentsTransactions = (startDate,endDate,onSuccess=()=>{},onFailure=()=>{})=>{
    return{
        type:GET_AGENTS_TRANSACTIONS,
        payload: {
            url:GET_AGENTS_TRANSACTIONS_URL,
            api:postCall,
            apiPayload:{
              operatorCode:global.operatorCode,
              startDate:startDate,
              endDate:endDate
            },
            onSuccess:onSuccess,
            onFailure:onFailure   
        }
    }
}

export const createAgentTransaction = ({
    agentId, 
    date, 
    amount, 
    paymentType, 
    status, 
    refId,
    description,
    payments = null
},onSuccess=()=>{},onFailure=()=>{}) =>{
    return {
        type:CREATE_AGENT_TRANSACTION,
        payload:{
            url:CREATE_AGENT_TRANSACTION_URL,
            api:postCall,
            apiPayload:{
                operatorCode:global.operatorCode,
                data:{
                    agentId:agentId, 
                    date:date,
                    amount:amount,
                    paymentType:paymentType,
                    status:status,
                    refId:refId,
                    description:description,
                    payments:payments
                }
            },
            onSuccess:onSuccess,
            onFailure:onFailure
        }
    }
}


export const updateAgentType=(agentId,postPaidLimit,onSuccess=()=>{},onFailure=()=>{})=>{
    var updated = postCall(UPDATE_AGENT_TYPE_URL, {
        agentId: agentId,
        postPaidLimit : postPaidLimit
      });
      updated.then((data) => {
        if(data){
          onSuccess();
        }else{
          onFailure(data.payload.Message);
        }
      })
      .catch((reason)=> {
        onFailure("Failed to update agent");
      })
}


export const updateAgentTransaction=(agentTransactionId,status,amount,onSuccess=()=>{},onFailure=()=>{})=>{
  var updated = postCall(UPDATE_AGENT_TRANSACTION_STATUS_URL, {
      agentTransactionId : agentTransactionId,
      status:status,
      amount:amount
    });
    updated.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
        onSuccess();
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Falied to update transaction");
    })
}

export const getAgentsByOperatorCode=(onSuccess=()=>{},onFailure=()=>{})=>{
  var updated = postCall(GET_AGENTS_BY_OPERATOR_CODE_URL, {
    operatorCode:global.operatorCode,
    });
    updated.then((data) => {
      if(data){
        onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to update agent");
    })
}

export const getAgentNamesByOperatorCode=(onSuccess=()=>{},onFailure=()=>{})=>{
  var updated = postCall(GET_AGENT_NAMES_BY_OPERATOR_CODE_URL, {
    privilege:global.privilege,
    operatorCode:global.operatorCode,
  });
  updated.then((data) => {
    if(data){
      onSuccess(data.payload.Payload);
    }
    else{
      onFailure(data.payload.Message);
    }
  })
  .catch((reason)=> {
    onFailure("Failed to get agent privileges by operator code");
  })
}

export const getPrepaidOTAAccountData=(agentIdDetails, onSuccess=()=>{},onFailure=()=>{})=>{
  let srmsAgentId = agentIdDetails.srmsAgentId;
  let northAgentId = agentIdDetails.northAgentId;
  let b2bAgentId = agentIdDetails.b2bAgentId;
  var fetchB2B = postCall(API_B2B_ADMIN_BASE_URL+GET_PREPAID_OTA_ACCOUNT_URL, {
    operatorCode:global.operatorCode,
    agentId: b2bAgentId
  });
  var fecthSRMS = postCall(API_SRMS_ADMIN_BASE_URL+GET_PREPAID_OTA_ACCOUNT_URL, {
    operatorCode:global.operatorCode,
    agentId: srmsAgentId
  });
  var fetchNorth = postCall(API_NORTH_ADMIN_URL+GET_PREPAID_OTA_ACCOUNT_URL, {
    operatorCode:global.operatorCode,
    agentId: northAgentId
  });
  Promise.all([fetchB2B,fecthSRMS, fetchNorth]).then(function(promiseData) {
    let b2bData = promiseData[0];
    let srmsData = promiseData[1];
    let northData = promiseData[2];
    if(b2bData.status == "SUCCESS"&&srmsData.status == "SUCCESS"&&northData.status == "SUCCESS"&&b2bData.payload.Status == "SUCCESS"&&srmsData.payload.Status == "SUCCESS"&&northData.payload.Status == "SUCCESS"){
      let finalData = {
        amountDeducted:b2bData.payload.Payload.amountDeducted+srmsData.payload.Payload.amountDeducted+northData.payload.Payload.amountDeducted,
        balanceAmount:b2bData.payload.Payload.balanceAmount+srmsData.payload.Payload.balanceAmount+northData.payload.Payload.balanceAmount,
        cancelledCount:b2bData.payload.Payload.cancelledCount+srmsData.payload.Payload.cancelledCount+northData.payload.Payload.cancelledCount,
        confirmedCount:b2bData.payload.Payload.confirmedCount+srmsData.payload.Payload.confirmedCount+northData.payload.Payload.confirmedCount,
        dayStartBalance:b2bData.payload.Payload.dayStartBalance+srmsData.payload.Payload.dayStartBalance+northData.payload.Payload.dayStartBalance,
        topUpForToday:b2bData.payload.Payload.topUpForToday+srmsData.payload.Payload.topUpForToday+northData.payload.Payload.topUpForToday
      }
      onSuccess(finalData);
    }else{
      onFailure("Failed to get agent");
    }
  }).catch((reason)=> {
    onFailure("Failed to get agent");
  })
  .catch((reason)=> {
    onFailure("Failed to get agent");
  })
}

export const getAgentPrivileges = (onSuccess=()=>{},onFailure=()=>{})=>{
  return {
    type:GET_AGENT_PRIVILEGES,
    payload:{
      url:GET_AGENT_PRIVILEGES_URL+`?isAgentsPage=true`,
      api:getCall,
      apiPayload:{
        operatorCode:global.operatorCode,
        isAgentsPage:false
      },
      onSuccess:onSuccess,
      onFailure:onFailure
    }
  }
}

export const getOperatorPrivilegeActions = (privilege,onSuccess=()=>{},onFailure=()=>{})=>{
  return {
    type:GET_OPERATOR_PRIVILEGE_ACTIONS,
    payload:{
      url:GET_OPERATOR_PRIVILEGE_ACTIONS_URL,
      api:postCall,
      apiPayload:{
        operatorCode:global.operatorCode,
        privilege:privilege
      },
      onSuccess:onSuccess,
      onFailure:onFailure
    }
  }
}

export const insertOperatorPrivilegeAction= (privilege,agentAction,onSuccess=()=>{},onFailure=()=>{})=>{
  var insertedData = postCall(INSERT_OPERATOR_PRIVILEGE_ACTION_URL, {
    operatorCode:global.operatorCode,
    privilege:privilege,
    agentAction:agentAction
  });
  insertedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get user actions.")
    }
  })      
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to get user actions!");
  })
}

export const deleteOperatorPrivilegeAction = (privilege,agentAction,onSuccess=()=>{},onFailure=()=>{})=>{
  var deletedData = postCall(DELETE_OPERATOR_PRIVILEGE_ACTION_URL, {
    operatorCode:global.operatorCode,
    privilege:privilege,
    agentAction:agentAction
  });
  deletedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get user actions.")
    }
  })      
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to get user actions!");
  })
}

export const getOperatorMaxDiscountPrivilege = (privilege,onSuccess=()=>{},onFailure=()=>{})=>{
  var fetchedData = postCall(GET_OPERATOR_MAX_DISCOUNT_PRIVILEGE_URL, {
    operatorCode:global.operatorCode,
    privilege:privilege
  });
  fetchedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get max discount for privilege.")
    }
  })
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to get max discount for privilege!");
  })
}

// values carries only the fields being saved e.g. {maxDiscountValue,isPercentage}
// or {minFareForServerDiscount,maxFareForServerDiscount}
export const upsertOperatorMaxDiscountPrivilege = (privilege,values,onSuccess=()=>{},onFailure=()=>{})=>{
  var upsertedData = postCall(UPSERT_OPERATOR_MAX_DISCOUNT_PRIVILEGE_URL, {
    operatorCode:global.operatorCode,
    privilege:privilege,
    ...values,
    updatedBy:global.userName
  });
  upsertedData.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to save max discount for privilege.")
    }
  })
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to save max discount for privilege!");
  })
}

export const createAgentPrivilege = (privilege,onSuccess=()=>{},onFailure=()=>{})=>{
  var createAgentPrivilege = postCall(CREATE_AGENT_PRIVILEGE_URL, {
    operatorCode:global.operatorCode,
    privilege:privilege
  });

  createAgentPrivilege.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to create agent privilege.")
    }
  })      
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to create agent privilege!");
  })
}


export const createAgent= ({name,user_name,password,phone_number,privilege,location,commission,commission_percentage,ac_commission,
  ac_commission_percentage,hitech_commission,hitech_commission_percentage,agent_type,cancellation_penality_percentage,
  verify_otp_for_login,discount_percentage,discount_value,branch,operator_code,operatorCode,master_agent_id},onSuccess,onFailure) => {
  let resolvedOperatorCode = operator_code || operatorCode || global.operatorCode;
  let apiPayload = {
    agent:{name,user_name,password,phone_number,privilege,location,commission,commission_percentage,ac_commission,
      ac_commission_percentage,hitech_commission,hitech_commission_percentage,operator_code: resolvedOperatorCode,
      agent_type,cancellation_penality_percentage,verify_otp_for_login,discount_percentage,discount_value,branch,
      master_agent_id, updated_by: global.userName
    }
  }
  let created = postCall(CREATE_AGENT_URL, apiPayload);
  created.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload);
    }else{
      onFailure(data.payload.Message);
    }
  })
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to create agent!");
  })
}

export const updateAgent= ({id,name,user_name,password,phone_number,privilege,location,commission,commission_percentage,ac_commission,
  ac_commission_percentage,hitech_commission,hitech_commission_percentage,agent_type,cancellation_penality_percentage,
  verify_otp_for_login,discount_percentage,discount_value,branch,operator_code,operatorCode,master_agent_id},onSuccess,onFailure) => {
  let resolvedOperatorCode = operator_code || operatorCode || global.operatorCode;
  let apiPayload ={
    agent:{id:id,name,user_name,password,phone_number,privilege,location,commission,commission_percentage,
      ac_commission,ac_commission_percentage,hitech_commission,hitech_commission_percentage,operator_code:resolvedOperatorCode,
      agent_type,cancellation_penality_percentage,verify_otp_for_login,discount_percentage,discount_value,branch,
      master_agent_id, updated_by: global.userName
    }
  }

  let updated = postCall(UPDATE_AGENT_URL, apiPayload);
  updated.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload);
    }else{
      onFailure("Unable to update agent.");
    }
  })
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to update agent!");
  })
}

export const deleteAgent= (agentId,onSuccess,onFailure,operatorCode) => {
  let deleted = postCall(DELETE_AGENT_URL, {
    agentId:agentId,
    operator_code: operatorCode || global.operatorCode,
    updatedBy:global.userName
  });
  deleted.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload);
    }else{
      onFailure("Unable to delete agent.");
    }
  })
  .catch((reason)=> {
    console.error({reason});
    onFailure("Failed to delete agent!");
  })
}

export const updateAgentActiveStatus= (agentId,isActive,onSuccess,onFailure) => {
  let updated = postCall(UPDATE_AGENT_ACTIVE_STATUS_URL, {
    agentId:agentId,
    isActive:isActive,
    updatedBy:global.userName
  });
  updated.then((data) => {
    if(data.status == "SUCCESS"&&data.payload.Status == "SUCCESS"){
      onSuccess(data.payload);
    }else{
      onFailure(isActive === true ? "Unable to activate agent." : "Unable to in-activate agent.");
    }
  })
  .catch((reason)=> {
    console.error({reason});
    onFailure(isActive === true ? "Failed to activate agent!" : "Failed to in-activate agent!");
  })
}

export const getAgentUpdateLogsById = (agentId, onSuccess = () => {}, onFailure = () => {}) => {
  let fetched = postCall(GET_AGENT_UPDATE_LOGS_BY_ID_URL, {
    agentId: agentId
  });
  fetched.then((data) => {
    if(data.status == "SUCCESS" && data.payload.Status == "SUCCESS"){
      onSuccess(data.payload.Payload);
    }else{
      onFailure("Unable to get agent update logs.");
    }
  })
  .catch((reason) => {
    console.error({reason});
    onFailure("Failed to get agent update logs!");
  })
}

export const fetchAgentLedger = (fromDate,toDate,isAc,isBookingDate,onSuccess=()=>{},onFailure=()=>{}) => {
  return fetch(FETCH_AGENTS_LEDGER_URL,{
      method: "POST",
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({"fromDate" : fromDate,
                            "toDate": toDate,
                            "acType":isAc,
                            "isBookingDate": isBookingDate,
                            "operatorCode":global.operatorCode,
                            "travelsId":global.travelsId,
                            "agentId": global.agentId
                           })
  })
  .then(response => response.json())
  .then(data => {
      if(data.Status==="SUCCESS"){
          onSuccess(data.Payload.agentsLedger);
      }else{
          onFailure();
      }
  }).catch((reason)=> {
      onFailure();
      return false;
  });
}


export const fetchTransactionsByPnr = (pnrs,onSuccess=()=>{},onFailure=()=>{}) => {
  return fetch(FETCH_TRANSACTIONS_BY_PNR_URL,{
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({"pnrs":pnrs,
                          "operatorCode":global.operatorCode,
                          "travelsId":global.travelsId
    })
  })
  .then(response => response.json())
  .then(data => {
      if(data.Status==="SUCCESS"){
          onSuccess(data.Payload);
      }else{
          onFailure();
      }
  }).catch((reason)=> {
      onFailure();
      return false;
  });
}

export const fetchPostPaidAgentUnpaidTickets = (agentId, onSuccess=()=>{},onFailure=()=>{}) => {
  return fetch(FETCH_POST_PAID_AGENT_UNPAID_TICKETS_URL,{
    method: "POST",
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({"operatorCode":global.operatorCode,
                          "agentId":agentId
    })
  })
  .then(response => response.json())
  .then(data => {
      if(data.Status==="SUCCESS"){
          onSuccess(data.Payload);
      }else{
          onFailure();
      }
  }).catch((reason)=> {
    onFailure();
    return false;
  });
}